import React from 'react';
export const ThemeContext = React.createContext({
    colorScheme: 'light',
    theme: null,
    common: null,
});
//# sourceMappingURL=novu-theme.context.js.map